export const BASE_PATH = "/kimyo/shinda/";

export const RESULT_PATTERN = [
  "スライム（Lv.99）",
  "黒い球体",
  "時間という概念",
  "捨てられた名刺",
  "史上最大のミジンコ",
  "炭酸の抜けたコーラ",
  "ネガティブなドジっ子",
  "ボンドの水溜り",
  "夢の終わり",
  "ゴリラ界のチャンピオン",
  "美形なブルドック",
  "歪んだ定規",
  "美女のリップクリーム",
  "新しい宇宙の法則",
  "道端の石ころ",
  "ズンドコベロンチョ",
  "世界を支配するAI",
  "嘘つきなインスタグラマー",
  "ストーリー・テラー",
  "美女缶",
  "イマキヨさん",
  "パンの袋をとめるやつ",
  "誇り高き消しカス",
  "世界遺産に選ばれるトイレ",
  "雲のできるコミケ会場",
  "この世にない色の鉛筆",
  "ちょうどいい収納スペース",
  "行列のできるATM",
  "美女か野獣",
  "有能なメガネ拭き",
  "細身のフードファイター",
  "視聴者3人（内訳：父、母、妹）のゲーム実況者",
  "最強の下っ端",
  "非の打ち所のない立方体",
  "素数という概念",
  "出汁",
  "何かのうわずみ",
  "再現Vの常連俳優",
  "美しすぎる細胞",
  "キーボードの“ま”",
  "Wi-Fi",
  "ごきげんなオランウータン",
  "レ点",
  "大富豪の飼い犬",
  "フタの裏についたヨーグルト",
  "人間としゃべれる猫",
  "機密書類",
  "余ったネジ",
  "テレホンカードの穴",
  "プライドの高い虫",
  "1000年に一度の美少女",
  "気まぐれなロボット掃除機",
  "カラフルな忍者",
  "何かの部品",
  "希望にあふれたイワシ",
  "保護シートに入った気泡",
  "イケメンのゴリラ",
  "黒っぽい何か",
  "現代アート",
  "完璧な輪ゴム",
  "万能なネギ",
  "タピオカミルクティー",
  "粗品",
  "いい感じの大統領",
  "打ち切り漫画の主人公",
  "サードウェーブ男子",
  "能力者",
  "笑顔が素敵なゴリラ",
  "運動神経バツグンのゴリラ",
  "自我を持った産業用ロボット",
  "ファナモ",
  "よれよれの保護フィルム",
  "サングラスをかけたサイボーグ",
  "汗のしみたミサンガ",
  "点P",
  "作用点",
  "落書きされた偉人",
  "だんごの長男",
  "タイムリープを繰り返す魔法少女",
  "最後まで使われない消しゴム",
  "謎の老婆",
  "仮面をつけたバイク乗り",
  "This Man",
  "アヌンナキ",
  "銀河をつかさどる魔王",
  "404姉さん",
  "美少年のキューティクル",
  "チャリできた中学生",
  "草",
  "wwwww",
  "ピグミーマーモセット",
  "モンゴリアンデスワーム",
  "笑わないセールスマン",
  "短パン小僧",
  "桃から生まれたヒーロー",
  "あの…なんだっけ…あの……アレ",
  "ブウウ――――――ンンン――――――ンンンン………………",
  "激怒して友のために走る羊飼い",
  "丸メガネの魔法使い",
  "川に出現するアザラシ",
  "4回くらい形態を変えるラスボス",
  "借りパクされるビニール傘",
  "惑星ニビル",
  "未来で待ってるイケメン",
  "カメラを止めない監督",
  "時速8kmで歩くたかしくん",
  "消えない指紋",
  "禁じられた遊び"
];

export const AUDIO_SRC = {
  NOISE_NORMAL: `${BASE_PATH}sound/noise-normal.mp3`,
  NOISE_STRANGE: `${BASE_PATH}sound/noise-strange.mp3`,
  CHILD: `${BASE_PATH}sound/child1.mp3`,
  ERROR: `${BASE_PATH}sound/error1.mp3`,
  ERROR_LONG: `${BASE_PATH}sound/error-long.mp3`,
  SWITCH_NOISE: `${BASE_PATH}sound/switch-noise.mp3`,
  YONIMO: `${BASE_PATH}sound/yonimo.mp3`
};
